'use strict';

import { createContext, useContext } from 'react';
import { ContentModuleDataContextType, KnipsDataContextType } from '../types';

// KNIPS CONTEXT
export const KnipsDataContext = createContext<KnipsDataContextType>({} as KnipsDataContextType);
export const KnipsDataProvider = KnipsDataContext.Provider;
export const KnipsDataConsumer = KnipsDataContext.Consumer;
export const useKnipsDataContext = function useDataContext() {
  return useContext(KnipsDataContext);
};

export const getKnipsDataContext = function getKnipsDataContext(dataId: string) {
  const ele = document.getElementById(dataId);
  return (ele ? JSON.parse(ele.textContent || '{}') : {}) as KnipsDataContextType;
};

// CONTENT MODULE CONTEXT
export const ContentModuleDataContext = createContext<ContentModuleDataContextType>({} as ContentModuleDataContextType);
export const ContentModuleDataProvider = ContentModuleDataContext.Provider;
export const ContentModuleDataConsumer = ContentModuleDataContext.Consumer;
export const useContentModuleDataContext = function useDataContext() {
  return useContext(ContentModuleDataContext);
};

export const getContentModuleDataContext = function getContentModuleDataContext(dataId: string) {
  const ele = document.getElementById(dataId);
  return (ele ? JSON.parse(ele.textContent || '{}') : {}) as ContentModuleDataContextType;
};
